'use client';

import { FunctionComponent } from 'react';
import { msg } from '@/services/isomorphic/I18NService';

import ConfigurationService from '@/services/isomorphic/ConfigurationService';
import { useSearchBox } from '@/react/hooks/useSearchBox';
import { SearchInput } from '../Search/SearchInput';

import S from './styles.base.module.scss';
import { general_errors_notFound_bodyMessage1 } from "@/lang/__generated__/ahnu/general_errors_notFound_bodyMessage1";
import { general_errors_notAvailable_bodyMessage1 } from "@/lang/__generated__/ahnu/general_errors_notAvailable_bodyMessage1";
import { general_errors_headlineMessage } from "@/lang/__generated__/ahnu/general_errors_headlineMessage";
import { general_errors_bodyMessage2 } from "@/lang/__generated__/ahnu/general_errors_bodyMessage2";
import { general_errors_tryNewSearch } from "@/lang/__generated__/ahnu/general_errors_tryNewSearch";

/**
 * Enum that represents different types of pages that can display an error..
 */
export enum ErrorPageType {
  NotFound = 'notFound',
  NotAvailable = 'notAvailable'
}

interface IErrorProps {
  /**
   * The given page type for this component.
   */
  pageType: ErrorPageType;
}

/**
 * 'Error' is a component that when a user reaches the page
 * they requested, the URL path provided no information.
 */
export const PageError: FunctionComponent<IErrorProps> = ({ pageType }) => {
  const config = ConfigurationService.getConfig('pageError');
  const showSearchBox = config.getSetting('showSearchBox').value;
  const [vm, { navigate, isNavigatingToResults }] = useSearchBox();

  const bodyMessageMap: Record<ErrorPageType, string> = {
    [ErrorPageType.NotFound]: msg(general_errors_notFound_bodyMessage1),
    [ErrorPageType.NotAvailable]: msg(
      general_errors_notAvailable_bodyMessage1
    )
  };

  return (
    <div className={S.container}>
      <div className={S.content}>
        <h2 className={S.titleText}>{msg(general_errors_headlineMessage)}</h2>
        <span className={S.text}>{bodyMessageMap[pageType]}</span>
        <div className={S.textContainer}>
          <span className={S.text}>{msg(general_errors_bodyMessage2)}</span>
        </div>
        {showSearchBox && (
          <div className={S.searchContainer}>
            <h3 className={S.searchTitle}>
              {msg(general_errors_tryNewSearch)}
            </h3>
            <SearchInput
              className={S.search}
              vm={vm}
              onNavigate={navigate}
              isNavigating={isNavigatingToResults}
            />
          </div>
        )}
      </div>
    </div>
  );
};
